import { IConfigState } from '../../types/config';
import { TReduxActions } from '../../types/redux';

export const configReducer = (state: IConfigState, action: TReduxActions) => {
  switch (action.type) {
    default:
      return state || {};
  }
};
